export const KNOWLEDGE_BASE_URL = {
  YIELDBIRDS_AD_UNIT:
    'https://www.notion.so/yieldbird-materials/Yieldbird-Ad-unit-31461213c49b80058f47ed347f428177',
} as const
